import { liveFeed } from "@/mocks/guaData";

const tagTone: Record<string, string> = {
  新瓜: "text-primary-700 bg-primary-100",
  热评: "text-accent-800 bg-accent-100",
  实锤: "text-foreground-900 bg-foreground-100",
  辟谣: "text-secondary-800 bg-secondary-200",
};

export default function LiveFeed() {
  return (
    <section id="live-feed" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="mb-1.5 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-700">
              <span className="h-2 w-2 animate-blinkDot rounded-full bg-primary-500" />
              Live · 实时滚动
            </p>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              最新瓜单，正在上桌
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            {["全部", "新瓜", "热评", "实锤", "辟谣"].map((f, i) => (
              <button
                key={f}
                type="button"
                className={`whitespace-nowrap cursor-pointer rounded-full px-3 py-1 transition ${
                  i === 0
                    ? "bg-foreground-950 text-background-50"
                    : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          {liveFeed.map((item, i) => (
            <a
              key={`${item.time}-${i}`}
              href="#comment-talk"
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200/60 bg-background-50 px-4 py-3 transition hover:border-primary-200"
            >
              <span className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${tagTone[item.tag] ?? "bg-secondary-100 text-secondary-800"}`}>
                {item.tag}
              </span>
              <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                {item.title}
              </span>
              <span className="shrink-0 whitespace-nowrap text-xs text-foreground-400">{item.time}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}